import DashboardTypes from './DashboardTypes.ts';

export const getOpenBidsInProgress = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_BIDS_PROGRESS,
  };
};

export const getOpenBidsInSuccess = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_BIDS_SUCCESS,
  };
};

export const getOpenBidsInError = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_BIDS_ERROR,
  };
};

export const getLastSevenDaysDataInProgress = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_PROGRESS,
  };
};

export const getLastSevenDaysDataInSuccess = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_SUCCESS,
  };
};

export const getLastSevenDaysDataInError = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_ERROR,
  };
};

export const getAwardedBidsInProgress = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_AWARDED_BIDS_PROGRESS,
  };
};

export const getAwardedBidsInSuccess = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_AWARDED_BIDS_SUCCESS,
  };
};

export const getAwardedBidsInError = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_AWARDED_BIDS_ERROR,
  };
};

export const getOpenBidsAgingInProgress = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_AGING_PROGRESS,
  };
};

export const getOpenBidsAgingInSuccess = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_AGING_SUCCESS,
  };
};

export const getOpenBidsAgingInError = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OPEN_AGING_ERROR,
  };
};

export const getOverallTimeLineInProgress = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OVERALL_TIMELINE_PROGRESS,
  };
};

export const getOverallTimeLineInSuccess = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OVERALL_TIMELINE_SUCCESS,
  };
};

export const getOverallTimeLineInError = (payload) => {
  return {
    payload,
    type: DashboardTypes.GET_OVERALL_TIMELINE_ERROR,
  };
};
